import { useState } from "react";
import Icon, {
    BranchesOutlined,
    CalendarFilled,
    CameraFilled,
    TableOutlined,
} from "@ant-design/icons";
import { Col, Menu, Drawer, Button, Space } from "antd";
import { Link } from "react-router-dom";
import "./index.scss";
import MenuContainer from "./menuContainer";
const { SubMenu } = Menu;
const MenuLeft = ({ toggleMenu, visible, setVisible }) => {
    const [placement, setPlacement] = useState("left");
    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };

    const onChange = (e) => {
        setPlacement(e.target.value);
    };
    return (
        <>
            <Col
                span={toggleMenu ? 2 : 4}
                gutter={6}
                xs={0}
                sm={0}
                md={0}
                lg={5}
                xl={toggleMenu ? 2 : 4}
                xxl={toggleMenu ? 2 : 4}
            >
                <Col span={22} className="menu">
                    <MenuContainer toggleMenu={toggleMenu}/>
                </Col>
            </Col>
            <Drawer
                title="Menu"
                placement={placement}
                closable={false}
                onClose={onClose}
                visible={visible}
                key={placement}
                style={{padding: 0}}

                extra={
                    <Space>
                        <Button onClick={onClose}>Close</Button>
                    </Space>
                }
            >
                <Col span={22} className="menu">
                    <MenuContainer toggleMenu={toggleMenu} />
                </Col>
            </Drawer>
        </>
    );
};
export default MenuLeft;
